import type {
  ProjectActionHandlers,
  ProjectMenuItem,
  ProjectResponse,
  ProjectType,
} from '@/types';
import { Pencil, Trash, ImagePlus, Copy, UserPlus } from 'lucide-react';

export function buildProjectMenuItems(
  projectType: ProjectType,
  handlers: ProjectActionHandlers,
  isCompany: boolean = false
): ProjectMenuItem<ProjectResponse>[] {
  const { onEdit, onChangeThumbnail, onDuplicate, onAssignMentor, onDelete, onMoveToBoard } =
    handlers;

  const items: ProjectMenuItem<ProjectResponse>[] = [];
  const isExternal = projectType === 'EXTERNAL';
  const canManageExternal = !isExternal || isCompany;

  if (onEdit && canManageExternal) {
    items.push({
      key: 'edit',
      label: 'Edit',
      icon: <Pencil className="h-4 w-4" />,
      onSelect: ({ project }) => onEdit(project),
    });
  }

  if (onChangeThumbnail && canManageExternal) {
    items.push({
      key: 'change-thumbnail',
      label: 'Change Thumbnail',
      icon: <ImagePlus className="h-4 w-4" />,
      onSelect: ({ project }) => onChangeThumbnail(project),
    });
  }

  if (onDuplicate) {
    items.push({
      key: 'duplicate',
      label: 'Duplicate Project',
      icon: <Copy className="h-4 w-4" />,
      disabled: projectType === 'EXTERNAL',
      onSelect: ({ project }) => onDuplicate(project),
    });
  }

  if (onAssignMentor && !(isExternal && isCompany)) {
    items.push({
      key: 'assign-mentor',
      label: 'Assign Mentor',
      icon: <UserPlus className="h-4 w-4" />,
      onSelect: ({ project }) => onAssignMentor(project),
    });
  }

  if (onDelete && canManageExternal) {
    items.push({ key: 'sep-1', type: 'separator' });
    items.push({
      key: 'delete',
      label: 'Delete',
      icon: <Trash className="h-4 w-4" />,
      destructive: true,
      onSelect: ({ project }) => onDelete(project),
    });
  }

  if (onMoveToBoard) {
    items.push({ key: 'sep-2', type: 'separator' });
    items.push({
      key: 'move-to-board',
      label: 'Move to Board',
      onSelect: ({ project }) => onMoveToBoard(project),
      disabled: projectType === 'EXTERNAL',
      icon: <ImagePlus className="h-4 w-4" />,
      
    })
  }

  return items;
}
